import api from "../helpers/api";

class CompanyService{

      
    async create_company(data) {
        
        return await api.post(`/companies`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async get_companies(page = 1){
        return await api.get(`companies?page=${page}`).then(
            response => {
                return response.data
            }
        )
    }

    async get_company(id){
        return await api.get(`companies/${id}`).then(
            response => {
                return response.data
            }
        )}
        
    async update_company(data){
        return await api.put(`companies/${data.id}`,data).then(
            response => {
                return response.data
            }
        )}

    async delete_company(id){
        return await api.delete(`company/${id}`).then(
            response => {
                return response.data
            }
        )
    }
    
    addCeo(companyId, ceoData) {
        return api.post(`/companies/${companyId}/ceos`, ceoData);
    }

    editCeo(companyId, ceoId, ceoData) {
        return api.put(`/companies/${companyId}/ceos/${ceoId}`, ceoData);
    }

    deleteCeo(companyId, ceoId) {
        return api.delete(`/companies/${companyId}/ceos/${ceoId}`);
    }

    // import companies in an excel file 
    async import_companies(data){
        return await api.post(`import-companies`,data).then(
            response => {
                return response.data.data;
            }
        )
    }

     // export actions in an excel file 
     async export_companies(data){
        return await api.post(`companies/export`,data,{
            responseType: "blob", // Ensures the response is treated as a file
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exported_companies.csv"); // Adjust the filename as needed
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Export failed:", error);
          throw error; 
        });
    }

    async search_company(query) {
        try {
            const response = await api.get(`/company/search`, {
            params: { q: query },
            });
            return response.data;
        } catch (error) {
            console.error("Error searching company:", error);
            throw error;
        }
    }
    
    //get 
    async get_company_plot(yearParam,company_id){
        return await api.get(`company-actions-data/${yearParam}/${company_id}`).then(
            response => {
                return response.data
            }
        )
    }

    async actions_by_company(yearParam){
        return await api.get(`charts/companies-by-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    async top_company_actions(yearParam){
        return await api.get(`top-companies-by-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    async company_type_distribution(){
        return await api.get(`company-type-distribution/`,
            { headers: { "Content-Type": "application/json" } }

        ).then(
            response => {
                return response.data
            }
        )
    }

    async company_type_actions(yearParam){
        return await api.get(`/company-type-by-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    async company_by_intention(yearParam){
        return await api.get(`/company-by-intention/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    async company_by_response(yearParam){
        return await api.get(`/company-by-response/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

   
}
export default new CompanyService;